// extracted by mini-css-extract-plugin
export default {"svg-mask":"svg-mask__Y_Lhv"};